export enum CareTeamStatus {
  /**
   * The care team has been drafted and proposed, but
   * not yet participating in the coordination and
   * delivery of patient care.
   */
  Proposed = 'proposed',
  /**
   * The care team is currently participating in the coordination
   * and delivery of care.
   */
  Active = 'active',
  /**
   * The care team is temporarily on hold or suspended and not participating in
   * the coordination and delivery of care.
   */
  Suspended = 'suspended',
  /**
   * The care team was, but is no longer, participating in the coordination
   * and delivery of care.
   */
  Inactive = 'inactive',
  /**
   * The care team should have never existed.
   */
  EnteredInError = 'entered-in-error',
}

export enum CareTeamCategory {
  EverydayCare = 'everyday-care',
}

export const CareTeamCategoryLabel = {
  [CareTeamCategory.EverydayCare]: 'Everyday Care',
};

export enum CareTeamRole {
  Pediatrician = 'pediatrician',
  SleepSpecialist = 'sleep-specialist',
  NutritionSpecialist = 'nutrition-specialist',
  LactationSpecialist = 'lactation-specialist',
  DevelopmentExpert = 'development-expert',
}

export const CareTeamRoleSnomedCodes = {
  [CareTeamRole.Pediatrician]: '82296001',
  [CareTeamRole.SleepSpecialist]: undefined,
  [CareTeamRole.NutritionSpecialist]: '768827000',
  [CareTeamRole.LactationSpecialist]: '225726006',
  [CareTeamRole.DevelopmentExpert]: undefined,
};

export const CareTeamRoleLabel = {
  [CareTeamRole.Pediatrician]: 'Lead pediatrician',
  [CareTeamRole.SleepSpecialist]: 'Sleep specialist',
  [CareTeamRole.NutritionSpecialist]: 'Nutrition specialist',
  [CareTeamRole.LactationSpecialist]: 'Lactation specialist',
  [CareTeamRole.DevelopmentExpert]: 'Child development expert',
};

export interface CareTeamParticipant {
  memberReference: string;
  role: CareTeamRole;
}

export interface CareTeamCreate {
  identifier?: string;
  status: CareTeamStatus;
  subjectReference: string;
  category: CareTeamCategory;
  participants: CareTeamParticipant[];
}

export interface CareTeam extends CareTeamCreate {
  id: string;
}

export interface CareTeamPopulateOptions {
  state: string; // Two-letter state code
  roles: CareTeamRole[];
}
